<template>
  <div class="statement-ved">
    <h3 class="statement__title">Табель</h3>
    <button
      @click="showFilters = true"
      class="select-date__btn"
      v-if="mobileMode"
    >
      <i class="far fa-calendar-alt"></i> Выбрать дату
    </button>
    <div :class="['statement__filters', { 'show-filters': showFilters }]">
      <button
        class="filter__close-btn"
        @click="showFilters = false"
        v-if="mobileMode"
      >
        <i class="el-icon-circle-close"></i>
      </button>
      <span class="filter-title">Выберите дату</span>
      <el-select v-model="filters.month" placeholder="Месяц">
        <el-option
          v-for="item in supportData.months"
          :key="item.value"
          :label="item.name"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select v-model="filters.year" placeholder="Год">
        <el-option
          v-for="item in supportData.years"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button @click="runFilter" type="primary">Отфильтровать</el-button>

      <div class="statement__filters-buttons">
        <button
          v-if="!mobileMode"
          class="download-btn"
          :disabled="!tableData.length"
          @click="downloadData()"
        >
          <i class="el-icon-download"></i> Скачать ЗФО и О-ЗФО
        </button>
        <button
          v-if="!mobileMode"
          class="download-btn"
          :disabled="!setFilter"
          @click="downloadData('ofo')"
        >
          <i class="el-icon-download"></i> Скачать ОФО
        </button>
      </div>
    </div>
    <div v-if="!mobileMode" class="statement__table-wrap">
      <div class="statement__table">
        <div class="header">
          <div class="row-header">
            <span>№ П/П</span>
            <span>Дисциплина</span>
            <span>Форма обучения</span>
            <span>Группа</span>
            <div class="twin-row">
              <span>Количество (по видам работ)</span>
              <span>Проведение вебинаров (часы)</span>
              <span>Проведение лекций, консультаций, практических занятий</span>
              <span
                >Проверка контр. работ, эссе, рефератов, лабораторных работ</span
              >
              <span>Проверка курсовых работ (проектов)</span>
              <span>Проверка отчётов по практике</span>
              <span>Экзамены</span>
              <span>Индивидуальный проект</span>
            </div>
          </div>
        </div>

        <div class="body">
          <div class="row" v-for="(item, index) of tableData" :key="index">
            <span>{{ ++index }}</span>
            <div class="col-gname">
              <div
                class="col-gname__element"
                v-for="(elementCell, indexName) of item.cells"
                :key="indexName"
              >
                <span>{{ elementCell.discipline }}</span>
                <span>{{ elementCell.form }}</span>
                <div class="element__groups">
                  <span v-for="(name, idx) of elementCell.gname" :key="idx">{{
                    name
                  }}</span>
                </div>
                <span>{{ elementCell.webinarsOnlyCount || 0 }}</span>
                <span>{{ elementCell.lecturesCount || 0 }}</span>
                <span>{{ elementCell.routineWorksCount || 0 }}</span>
                <span>{{ elementCell.courseWorksCount || 0 }}</span>
                <span>{{ elementCell.practiceReportountsCount || 0 }}</span>
                <span>{{ elementCell.examGradesCount || 0 }}</span>
                <span>{{ elementCell.individualWorksCount || 0 }}</span>
              </div>
            </div>
          </div>
          <div class="row-empty" v-if="!tableData.length">
            <span>Нет данных</span>
          </div>
        </div>

        <div class="footer">
          <div class="row-footer" v-if="tableData.length">
            <span class="row-footer__first">Итог по разделам:</span>
            <div class="sub-row">
              <span>{{ sumResults.webinarsOnlyCount || 0 }}</span>
              <span>{{ sumResults.lecturesCount || 0 }}</span>
              <span>{{ sumResults.routineWorksCount || 0 }}</span>
              <span>{{ sumResults.courseWorksCount || 0 }}</span>
              <span>{{ sumResults.practiceReportountsCount || 0 }}</span>
              <span>{{ sumResults.examGradesCount || 0 }}</span>
              <span>{{ sumResults.individualWorksCount || 0 }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="slider-wrp">
      <slider
        @next="updateCurrentSlide"
        @prev="updateCurrentSlide"
        ref="slider"
        :closeBtn="false"
      >
        <div
          class="slide__container"
          v-for="(item, index) of tableData"
          :key="index"
        >
          <div class="slide" v-if="tableData.length">
            <div class="top-section">
              <button
                :class="{ 'disable-arrow': currentSlide === 0 }"
                @click="prev"
              >
                <i class="el-icon-arrow-left"></i>
              </button>
              <span>{{ setFilter.month.name }}</span>
              <span>{{ setFilter.year }}</span>
              <button
                :class="{
                  'disable-arrow': tableData.length - 1 === currentSlide,
                }"
                @click="next"
              >
                <i class="el-icon-arrow-right"></i>
              </button>
            </div>
            <div class="left-section">
              <span>№ П/П</span>
              <span>Дисциплина</span>
              <span>Форма обучения</span>
              <span>Группа</span>
              <span>Проведение вебинаров (часы)</span>
              <span
                >Проверка контр. работ, эссе, рефератов, лабораторных
                работ</span
              >
              <span>Проверка курсовых работ (проектов) (шт.)</span>
              <span>Проверка отчётов по практике (шт.)</span>
            </div>
            <div class="right-section">
              <span>{{ ++index }}</span>
              <span>{{ item.d_name }}</span>
              <div class="group-section">
                <div
                  v-for="(col, colIndex) of item.cells"
                  class="group-section__col"
                  :key="colIndex"
                >
                  <span>{{ col.form }}</span>
                  <div class="group-list">
                    <span v-for="(gname, idx) of col.gname" :key="idx">{{
                      gname
                    }}</span>
                  </div>
                  <span>{{ col.webinarsCount || 0 }}</span>
                  <span>{{ col.routineWorksCount || 0 }}</span>
                  <span>{{ col.courseWorksCount || 0 }}</span>
                  <span>{{ col.practiceReportountsCount || 0 }}</span>
                </div>
              </div>
            </div>
            <div class="bottom-section">
              <button
                class="download-btn"
                :disabled="!tableData.length"
                @click="downloadData()"
              >
                <i class="el-icon-download"></i> Скачать ЗФО и О-ЗФО
              </button>
              <button
                class="download-btn"
                :disabled="!setFilter"
                @click="downloadData('ofo')"
              >
                <i class="el-icon-download"></i> Скачать ОФО
              </button>
            </div>
          </div>
        </div>
      </slider>
    </div>
  </div>
</template>
<script>
import slider from "@/components/slider";
export default {
  data() {
    return {
      showFilters: false,
      currentSlide: 0,
      sumResults: {
        courseWorksCount: null,
        practiceReportountsCount: null,
        routineWorksCount: null,
        webinarsCount: null,
        individualWorksCount: null
      },
      tableData: [],
      setFilter: "",
      filters: {
        month: null,
        year: null,
      },
      supportData: {
        months: [
          {
            name: "Январь",
            value: '01',
          },
          {
            name: "Февраль",
            value: '02',
          },
          {
            name: "Март",
            value: '03',
          },
          {
            name: "Апрель",
            value: '04',
          },
          {
            name: "Май",
            value: '05',
          },
          {
            name: "Июнь",
            value: '06',
          },
          {
            name: "Июль",
            value: '07',
          },
          {
            name: "Август",
            value: '08',
          },
          {
            name: "Сентябрь",
            value: '09',
          },
          {
            name: "Октябрь",
            value: '10',
          },
          {
            name: "Ноябрь",
            value: '11',
          },
          {
            name: "Декабрь",
            value: '12',
          },
        ],
        years: [],
      },
    };
  },
  components: {
    slider,
  },
  computed: {
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },
  methods: {
    next() {
      this.$refs.slider.next();
    },
    prev() {
      this.$refs.slider.prev();
    },
    updateCurrentSlide(v) {
      this.currentSlide = v;
    },
    async runFilter() {
      this.setFilter = JSON.parse(JSON.stringify(this.filters));
      this.mobileMode ? (this.showFilters = false) : null;

      const date = `01.${this.filters.month.value}.${this.filters.year}`;

      try {
        const { data: { results, sumResults } } = await this.axios.get('/api/consolidatedstatement', { params: { date_filter: date } });

        if (results) {
          this.tableData = this.normalizeResponse(results);
          this.sumResults = sumResults;
        }

      } catch (error) {
        console.warn('Failed fetch [Statement/runFilter]', error);
      }
    },
    normalizeResponse(data) {
      let disciplines = [];
      for (let key in data) {
        let obj = { d_name: key };
        obj.cells = [];
        data[key].forEach(el => {
          obj.cells.push(el);
        });
        disciplines.push(obj);
      }
      return disciplines;
    },
    setDate() {
      let date = new Date();
      this.filters.month = {
        name: date.toLocaleString("ru", { month: "long" }),
        value: `${date.getMonth() > 9 ? '' : '0'}${date.getMonth() + 1}`,
      };
      let year = date.getFullYear();
      for (let i = 3; i >= 0; i--) {
        this.supportData.years.push({ value: year-- });
      }
      this.filters.year = date.getFullYear();
    },

    downloadData(type = null) {
      let obj = { date_filter:  `01.${this.setFilter.month.value}.${this.setFilter.year}`};

      if (type !== 'ofo') {
        obj.statement = this.tableData;
        obj.result = this.sumResults;
      }

      const fileDownload = require("js-file-download");
      const url = `/api/consolidatedstatement/${ type === 'ofo' ? 'exportOfo' : 'export'}`

      this.axios
        .request({
          responseType: "arraybuffer",
          url,
          method: "post",
          data: obj,
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(result => {
          fileDownload(
            result.data,
            `Ведомость_${this.setFilter.month.name}_${this.setFilter.year}.xls`
          );
        });
    },
  },
  mounted() {
    this.setDate();
  },
};
</script>

<style lang="scss">
$row-markup: 3% 20% 10% 10% 57%;

.statement-ved {
  width: 100%;
  row-gap: 20px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content max-content 1fr;
  height: 100%;
  justify-content: center;
  .statement__title {
    margin: 0;
  }
  .statement__filters {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(4, max-content) 1fr;
    column-gap: 15px;
    row-gap: 10px;
    align-items: center;

    &-buttons {
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-left: auto;
    }
  }
  .filter-title {
    color: $regular-text-clr;
  }
  .download-btn {
    justify-self: end;
    border: 1px solid $regular-text-clr;
    padding: 10px;
    text-align: center;
    border-radius: 5px;
    font-size: 14px;
    max-width: 200px;
    i {
      font-size: 16px;
    }
  }
  .select-date__btn {
    justify-self: center;
    display: grid;
    grid-template-columns: 20px 1fr;
    column-gap: 10px;
    justify-items: center;
    align-items: center;
    word-wrap: break-all;
    transition-duration: 0.3s;
    transition-property: color background-color;
    border: 1px solid $placeholder-text-clr;
    padding: 10px;
    border-radius: 10px;
    color: $brand-clr-1;
    max-width: max-content;
    font-size: 20px;
    background-color: rgba($color: $brand-clr-1, $alpha: 0.05);
    &:hover {
      border-color: $brand-clr-1;
      background-color: rgba($color: $brand-clr-1, $alpha: 1);
      color: $basic-white;
    }
    i {
      font-size: inherit;
    }
  }
  .download-btn:disabled {
    cursor: not-allowed;
    border-color: $placeholder-text-clr;
  }
  .statement__table-wrap {
    overflow-x: auto;
  }
  .statement__table {
    min-width: 1400px;
    font-size: 14px;
    color: $regular-text-clr;
    position: relative;
    height: auto;
    overflow-y: hidden;
    display: grid;
    grid-template-rows: auto 1fr max-content;
  }
  .header {
    padding-right: 8px;
    width: 100%;
    background-color: $extra-light-border;
  }
  .row-header {
    height: 100%;
    padding: 10px;
    justify-items: center;
    align-items: center;
    display: grid;
    grid-template-columns: $row-markup;
    border: none;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      border-left: 1px solid $placeholder-text-clr;
      text-align: center;
      font-weight: bold;
      padding: 5px;
    }
    span:first-child {
      font-size: 14px;
    }
  }

  .twin-row {
    display: grid;
    grid-template-columns: 1.1fr 1fr 1.1fr 0.9fr 0.9fr 0.9fr 0.9fr;
    border-right: 1px solid $placeholder-text-clr;
    span:nth-child(1) {
      grid-row-start: 1;
      grid-row-end: 1;
      grid-column-start: 1;
      grid-column-end: 8;
      border-bottom: 1px solid $placeholder-text-clr;
    }
  }
  .body {
    overflow-y: scroll;
    height: 100%;
  }
  .row {
    column-gap: 0;
    display: grid;
    grid-template-columns: 3% 20% 77%;;
    border-bottom: 1px solid $placeholder-text-clr;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      padding: 5px;
    }
  }
  .sub-row {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 15.7% 14.2% 15.7% 12.8% 12.8% 12.8% 15.6%;
  }
  .col-gname {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-start: 2;
    grid-column-end: 9;
    grid-row-start: 1;
    justify-self: start;
    width: 100%;
    height: 100%;
  }
  .col-gname__element {
    display: grid;
    border-left: 1px solid $base-border-clr;
    grid-template-columns: 20.7% 10.3% 10.5% 9.2% 8.4% 9.3% 7.6% 7.6% 7.5% 9.2%;
    // grid-template-columns: 13% 13% 12% 11% 11% 10% 10% 10% 10%;
    border-bottom: 1px solid $base-border-clr;
  }
  .col-gname__element:last-child {
    border-bottom: none;
  }
  .element__groups {
    display: grid;
    grid-template-columns: 1fr;
  }
  .row-empty {
    height: 100%;
    align-items: center;
    display: grid;
    padding: 20px;
    grid-template-columns: 1fr;
    justify-items: center;
  }
  .footer {
    padding-right: 8px;
    background-color: $extra-light-border;
  }
  .row-footer {
    font-weight: bold;
    text-align: center;
    padding: 10px;
    display: grid;
    justify-content: center;
    grid-template-columns: 43% 57%;
  }

  .row-footer__first {
    justify-self: start;
  }
  .slide {
    display: grid;
    row-gap: 10px;
    column-gap: 10px;
    grid-template-columns: 1.5fr 2fr;
    overflow-y: auto;
    grid-template-rows: max-content 1fr max-content;
  }
  .right-section,
  .left-section {
    height: 100%;
    display: grid;
    row-gap: 10px;
    align-items: center;
  }
  .top-section {
    width: 100%;
    grid-template-columns: 1fr repeat(2, max-content) 1fr;
    justify-items: center;
    justify-content: center;
    display: grid;
    grid-row-start: 1;
    grid-row-end: 1;
    grid-column-start: 1;
    grid-column-end: 3;
    margin: 0;
    column-gap: 10px;
    font-size: 18px;
    font-weight: bold;
    span {
      font-size: inherit;
    }
    i {
      font-size: 18px;
    }
  }
  .disable-arrow {
    color: $base-border-clr;
  }
  .left-section {
    grid-template-rows: 30px 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    font-weight: bold;
  }
  .right-section {
    grid-template-rows: 30px 1fr 6fr;
    span {
      text-align: center;
    }
    .group-section {
      overflow-x: auto;
      height: 100%;
      display: flex;
    }
    .group-section__col {
      display: grid;
      grid-template-rows: repeat(6, 1fr);
      row-gap: 10px;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
    .group-list {
      display: grid;
      grid-template-columns: 1fr;
    }
  }
  .bottom-section {
    display: grid;
    grid-column-start: 1;
    grid-column-end: 3;
  }
}
@media (max-width: 800px) {
  .statement-ved {
    .slider-wrp {
      position: relative;
    }
    .statement__filters {
      row-gap: 20px;
      padding: 20px 20px 20px 20px;
      position: absolute;
      transition-duration: 0.3s;
      transition-property: transform;
      transform: translateX(-120%);
      width: 100%;
      height: 100%;
      background-color: white;
      grid-template-columns: 1fr;
      grid-template-rows: repeat(6, max-content);
      justify-content: center;
      left: 0;
      top: 0;
      z-index: 22;
    }
    .show-filters {
      transform: translateX(0);
    }
    .filter-title {
      font-size: 18px;
    }
    .filter__close-btn {
      padding: 10px;
      justify-self: end;
      i {
        color: $brand-clr-1;
        font-size: 32px;
      }
    }
    .download-btn {
      justify-self: center;
      max-width: unset;
      width: 100%;

      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }
}
</style>
